export default __webpack_public_path__ + "static/media/俞敏洪半身像.64f67f94.png";